<template>
  <b-spinner :variant="variant" :small="small" />
</template>

<script>
export default {
  props: {
    variant: {
      type: String,
    },
    small: {
      type: Boolean,
    },
  },
};
</script>
